import { render } from "./intallClosely.vue?vue&type=template&id=d94ed6f0"
import script from "./intallClosely.vue?vue&type=script&lang=js"
export * from "./intallClosely.vue?vue&type=script&lang=js"

import "./intallClosely.vue?vue&type=style&index=0&id=d94ed6f0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/download-closely/intallClosely.vue'],['render',render],['__file',"intallClosely.vue"]])

export default __exports__